/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { REMOTE_DESKTOP_TYPE, RemoteDesktopModel, CitrixModel, RdpModel, VmwareViewModel } from './Model';

function createRemoteDesktopResource(id: string, resource: IResourceProps): RemoteDesktopModel | undefined {
    if (!resource || !resource.props || !resource.props.termtype) {
        return;
    }
    switch (resource.props.termtype) {
        case REMOTE_DESKTOP_TYPE.RDP:
            return new RdpModel(id, resource);
        case REMOTE_DESKTOP_TYPE.CITRIX:
            return new CitrixModel(id, resource);
        case REMOTE_DESKTOP_TYPE.VMWARE_VIEW:
            return new VmwareViewModel(id, resource);
        case REMOTE_DESKTOP_TYPE.NONE:
            throw new Error('Unable to create resource of type REMOTE_DESKTOP_TYPE.NONE');
    }
    return;
}

export { createRemoteDesktopResource as default, createRemoteDesktopResource };
